import React, { Suspense } from 'react';
import type {
  FacetChangeHandler,
  FacetConfig,
  FacetValue,
  SearchFilters,
  SearchResult,
  SolrResponse
} from '../../types';
import Loading from '../Loading/Loading';

interface SearchFacetsProps {
  filters: SearchFilters;
  facets: FacetConfig[];
  response: SolrResponse<SearchResult> | null;
  onChange: FacetChangeHandler;
}

export default function SearchFacets(
  props: SearchFacetsProps
): JSX.Element | null {
  const { facets, response } = props;
  return facets.length > 0 ? (
    <>
      {facets.map((facet, key) => {
        const Element = facet.facetHandler;
        const Fallback = facet.facetFallback ?? Loading;
        const userOnChange = facet.onChange;
        return (
          <div key={key} className={`facet-${facet.name}`}>
            <Suspense fallback={<Fallback label={facet.label} />}>
              <Element
                filters={props.filters}
                facet={facet}
                // @ts-ignore
                facetResult={response?.facetResults?.[facet.name]}
                facetResults={response?.facets ?? {}}
                onChange={
                  userOnChange
                    ? (facet: string, value: FacetValue) => {
                        props.onChange(facet, userOnChange(value));
                      }
                    : props.onChange
                }
              />
            </Suspense>
          </div>
        );
      })}
    </>
  ) : null;
}
